let fb = {
  	state: {
		fb:{}
  	},
  	mutations: {
        remove (state) {
			state.fb = {}
			sessionStorage.removeItem('fb')
        },
        add (state, data) {
			console.log(data)
			state.fb = data
			sessionStorage.setItem('fb',JSON.stringify(state))
        }
    }
}
let data = sessionStorage.getItem('fb')?JSON.parse(sessionStorage.getItem('fb')):{}
fb.state.fb = data


export default fb


// WEBPACK FOOTER //
// ./src/store/fb/index.js